import { isFunction, isWindow } from './type'

/**
 * 节流函数
 * @param {Function} fn
 * @param {Number} delay
 * @param  {...any} args
 * @returns {Function}  该Function的返回值是fn的返回值
 */
function throttle(fn, delay = 1000, ...args) {
    if (!isFunction(fn)) throw new Error(`${fn}不是一个函数，请传入一个函数进行节流`)
    const _this = this // call apply执行该防抖函数，保存_this
    let start = 0
    let end = 0
    return function(..._args) {
        end = Date.now()
        if (end - start < delay) return
        start = end
        // 如果返回的函数改变了this指向，就用该this，否则使用throttle的this
        return fn.apply(isWindow(this) ? _this : this, args.concat(_args))
    }
}

export default throttle
